import { useMemo } from 'react'

import { getUrl } from 'app/UrlService'
import { BreadcrumbsItem } from 'features/breadcrumbs/types'
import { useDetailViewContext } from 'features/views/DetailView/hooks/useDetailViewContext'

type BreadcrumbsDisplayItem = Omit<BreadcrumbsItem, 'type'> & {
    type: BreadcrumbsItem['type'] | 'object'
}

export function useDetailViewTopBarBreadcrumbsState() {
    const { breadcrumbs, recordManager, isEmbedded, object, stack } = useDetailViewContext()!

    const isError = recordManager.isError

    const objectBreadcrumbs: BreadcrumbsDisplayItem[] = useMemo(() => {
        if (!object || !stack) return []

        return [
            {
                type: 'object',
                label: object.name,
                path: getUrl(object.url, stack),
            },
        ]
    }, [object, stack])

    const mappedBreadcrumbs: BreadcrumbsDisplayItem[] = isEmbedded ? objectBreadcrumbs : breadcrumbs

    return useMemo(
        () => ({
            breadcrumbs: mappedBreadcrumbs,
            isError,
        }),
        [mappedBreadcrumbs, isError]
    )
}
